import type { AeropayUser } from '@iheartjane/data-access';
import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import type { ActionResult } from '@jane/bloom/types/remixAction';

export const useAeropayUser = () => {
  const fetcher = useFetcher<ActionResult<AeropayUser | null>>();

  const fetchAeropayUser = useCallback(() => {
    fetcher.load(`/api/aeropay-user`);
  }, [fetcher]);

  return {
    data: fetcher.data,
    fetchAeropayUser,
    state: fetcher.state,
  };
};
